import { PortalConversation } from "../apis/ApiPortalBackend";
import { ChatDataProps, ChatMessage } from "./backend/SengiLabsTypes";

//List of Languages
/**
 *  language code is ​"de-DE" for language ​" Deutsch"
    language code is ​"en-US" for language ​" US English"
    language code is ​"en-GB" for language ​" UK English Female"​
    language code is ​"en-GB" for language ​" UK English Male"​
    language code is ​"es-ES" for language ​" español"
    language code is ​"es-US" for language ​" español de Estados Unidos"
    language code is ​"fr-FR" for language ​" français"​
    language code is ​"hi-IN" for language ​" हिन्दी Hindi"
    language code is ​"id-ID" for language ​" Bahasa Indonesia"
    language code is ​"it-IT" for language ​" italiano"
    language code is ​"ja-JP" for language ​" 日本語"
    language code is ​"ko-KR" for language ​" 한국의"
    language code is ​"nl-NL" for language ​" Nederlands"
    language code is ​"pl-PL" for language ​" polski"
    language code is ​"pt-BR" for language ​" português do Brasil"
    language code is ​"ru-RU" for language ​" русский"
    language code is ​"zh-CN" for language ​" ​普通话（中国大陆）"
    language code is ​"zh-HK" for language ​" ​粤語（香港）"
    language code is ​"zh-TW" for language ​" 國語（臺灣）"
    */

export const KNOWN_CONTENT_TYPES: ChatDataProps['type'][] = ['code', 'video', 'text', 'image', 'pdf', 'mermaid'];
export type ChatRequestState =
    | null
    | "thinking"
    | "error";

export interface ChatRuntimeState {
    state: ChatRequestState;
    error: string | null;
    unread: boolean;
    messageRevision: number;
    // Bisher gestreamter Antworttext (null = kein Stream aktiv). Liegt im Runtime-State statt im
    // Component-State, damit eine laufende Antwort beim Chat-Wechsel weiterlaeuft und beim
    // Zurueckwechseln sichtbar ist.
    streamingText: string | null;
};

export interface UseChatHistoryOptions {
    defaultTitle?: string;
    onConversationCreated?: (conversation: PortalConversation) => void;
};

//Component
export interface ChatComponentProps {
    id:string;
    items: ChatDataProps[];
    codeStyleClass?: string;
    componentClass?: string;
    imageAltProp?: string;
    imageClass?:string;
    imageHeight?: string;
    imageWidth?: string;
    pdfHeight?: string;
    pdfWidth?: string;
    textClass?: string;
    videoControlls?: boolean;
    videoHeight?:string;
    videoWidth?: string;
};

export interface ChatProps  {
  chatID: string;
  getChatMessages?: (messages:ChatMessage[]) => void;
  defaultChatTitle?: string;
  onConversationCreated?: (conversation: PortalConversation) => void;
};

export interface PendingChatFile {
    file: File;
    type: 'image' | 'pdf';
    previewUrl: string;
    content: string;
};
export type ChatResponseState = | null | "thinking" | "error";